<admin-layout pageTitle="Integração SRG-SCL">
    <div actions class="toolbar-actions">
        @if (state === 'ready' && showAll) {
        <span class="env-chip">{{ overview.length }} associações</span>
        } @else if (state === 'ready') {
        <span class="env-chip" [class.prod]="isProduction" [class.on]="settings?.enabled">
            {{ associationId }} · {{ settings?.enabled ? 'Habilitada' : 'Desabilitada' }}
        </span>
        }
    </div>

    <section class="settings-page">
        @if (state === 'loading') {
        <div class="center"><mat-spinner diameter="32"></mat-spinner></div>
        } @if (state === 'unavailable') {
        <div class="settings-card center">
            <p>
                Integração SRG-SCL não está disponível na API de
                <strong>{{ envLabel }}</strong> (endpoint ausente).
            </p>
            <p class="hint">
                Use o ambiente <strong>Homologação</strong> no banner para configurar e monitorar o
                SRG-SCL.
            </p>
        </div>
        } @if (state === 'error') {
        <div class="settings-card center">
            <p>Não foi possível carregar a configuração.</p>
            <button mat-stroked-button (click)="refresh()">Tentar novamente</button>
        </div>
        } @if (state === 'ready' && showAll) {
        <div class="settings-card">
            <div class="card-accent"></div>
            <div class="card-body">
                <div class="head-row">
                    <div>
                        <div class="section-head">Associações</div>
                        <p class="hint">
                            Escolha uma para configurar o token e ver só os clientes dela.
                        </p>
                    </div>
                    @if (!isProduction) {
                    <button mat-flat-button color="primary" type="button" (click)="creating = !creating">
                        {{ creating ? 'Fechar' : 'Nova associação' }}
                    </button>
                    }
                </div>
                @if (creating) {
                <form class="create-panel" [formGroup]="draft" (ngSubmit)="addAssociation()">
                    <div class="pair">
                        <mat-form-field appearance="outline">
                            <mat-label>Nome</mat-label>
                            <input matInput formControlName="name" autocomplete="organization" />
                            <mat-error>Informe o nome</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Sigla</mat-label>
                            <input matInput formControlName="id" maxlength="16" autocomplete="off" />
                            <mat-hint>Ex.: MG</mat-hint>
                            <mat-error>Sigla inválida</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="pair">
                        <mat-form-field appearance="outline">
                            <mat-label>Código SRG-SCL</mat-label>
                            <input matInput formControlName="code" inputmode="numeric" autocomplete="off" />
                            <mat-hint>O 13 é da APCBRH.</mat-hint>
                            <mat-error>Informe o código</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>URL base</mat-label>
                            <input matInput formControlName="baseUrl" autocomplete="off" />
                            <mat-error>Informe uma URL https válida</mat-error>
                        </mat-form-field>
                    </div>
                    <mat-form-field appearance="outline">
                        <mat-label>Token</mat-label>
                        <input matInput type="password" formControlName="token" autocomplete="new-password" />
                        <mat-error>Informe o token</mat-error>
                    </mat-form-field>
                    <div class="actions">
                        <button
                            mat-flat-button
                            color="primary"
                            type="submit"
                            [disabled]="adding || saving"
                        >
                            {{ adding ? 'Adicionando…' : 'Adicionar' }}
                        </button>
                    </div>
                </form>
                }
                <ul class="assoc-list">
                    @for (row of overview; track row.id) {
                    <li>
                        <div class="assoc-row">
                            <span class="sigla">{{ row.id }}</span>
                            <span class="who">
                                <span class="name">{{ row.name }}</span>
                                @if (row.code) {
                                <span class="code">Código {{ row.code }}</span>
                                }
                            </span>
                            <span class="pills">
                                @if (row.statusKnown && row.tokenConfigured) {
                                <span class="pill ok">Token@if (row.tokenHint) { ••••{{ row.tokenHint }} }</span>
                                } @else if (row.statusKnown) {
                                <span class="pill warn">Sem token</span>
                                }
                                @if (row.statusKnown) {
                                <span class="pill" [class.ok]="row.enabled" [class.off]="!row.enabled">
                                    {{ row.enabled ? 'Habilitada' : 'Desabilitada' }}
                                </span>
                                }
                            </span>
                            <span class="row-actions">
                                @if (!isProduction) {
                                <button
                                    mat-stroked-button
                                    type="button"
                                    [disabled]="editSaving"
                                    (click)="startEdit(row)"
                                >
                                    Editar
                                </button>
                                }
                                <button mat-button type="button" class="open" (click)="enterAssociation(row)">
                                    Abrir
                                </button>
                            </span>
                        </div>
                        @if (editingId === row.id) {
                        <form class="edit-panel" [formGroup]="edit" (ngSubmit)="saveEdit(row)">
                            <div class="section-head">Editar {{ row.id }}</div>
                            <mat-form-field appearance="outline">
                                <mat-label>Nome</mat-label>
                                <input matInput formControlName="name" autocomplete="organization" />
                                <mat-error>Informe o nome</mat-error>
                                @if (row.id === 'APCBRH') {
                                <mat-hint>A APCBRH não é renomeada aqui.</mat-hint>
                                }
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>URL base</mat-label>
                                <input matInput formControlName="baseUrl" autocomplete="off" />
                                <mat-error>Informe uma URL https válida</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Token</mat-label>
                                <input matInput type="password" formControlName="token" autocomplete="new-password" />
                                <mat-hint>
                                    {{ row.tokenConfigured ? 'Deixe em branco para manter o token atual.' : 'Obrigatório: ainda não há token.' }}
                                </mat-hint>
                            </mat-form-field>
                            <div class="toggle-row">
                                <mat-slide-toggle formControlName="enabled">Integração habilitada</mat-slide-toggle>
                            </div>
                            @if (editTestResult) {
                            <div class="test-result" [class.ok]="editTestResult.ok" [class.fail]="!editTestResult.ok" role="status">
                                {{ editTestResult.message }}
                            </div>
                            }
                            <div class="actions">
                                <button mat-stroked-button type="button" [disabled]="editTesting || editSaving" (click)="testEdit(row)">
                                    {{ editTesting ? 'Testando…' : 'Testar conexão' }}
                                </button>
                                <button mat-stroked-button type="button" [disabled]="editSaving || editTesting" (click)="cancelEdit()">
                                    Cancelar
                                </button>
                                <button mat-flat-button color="primary" type="submit" [disabled]="editSaving">
                                    {{ editSaving ? 'Salvando…' : 'Salvar' }}
                                </button>
                            </div>
                        </form>
                        }
                    </li>
                    }
                </ul>
            </div>
        </div>
        } @if (state === 'ready' && !showAll) {
        <div class="settings-card">
            <div class="card-accent"></div>
            <div class="card-body">
                @if (!settings?.encryptionAvailable) {
                <p class="warn">
                    O servidor não tem INTEGRATION_SETTINGS_KEY configurada: não é possível salvar.
                </p>
                } @if (!settings?.baseUrl) {
                <p class="hint">Nenhuma URL salva para esta associação.</p>
                }
                <form [formGroup]="form" (ngSubmit)="save()">
                    <div class="head-row">
                        <div class="section-head">
                            {{ associationId }}@if (associationName) { — {{ associationName }} }
                        </div>
                        @if (!isProduction) {
                        <button mat-stroked-button type="button" (click)="showDirectory()">Todas</button>
                        }
                    </div>
                    <mat-form-field appearance="outline">
                        <mat-label>URL base</mat-label>
                        <input
                            matInput
                            formControlName="baseUrl"
                            placeholder="https://..."
                            autocomplete="off"
                        />
                        <mat-hint>Endereço https do SRG-SCL desta associação.</mat-hint>
                        <mat-error>Informe uma URL https válida</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Token</mat-label>
                        <input
                            matInput
                            type="password"
                            formControlName="token"
                            autocomplete="new-password"
                        />
                        @if (settings?.tokenConfigured) {
                        <mat-hint>
                            Configurado (final ••••{{ settings?.tokenHint }}). Deixe em branco para
                            manter.
                        </mat-hint>
                        }
                    </mat-form-field>

                    <div class="section-head">Status</div>
                    <div class="toggle-row">
                        <mat-slide-toggle formControlName="enabled"
                            >Integração habilitada</mat-slide-toggle
                        >
                    </div>

                    @if (settings?.updatedBy) {
                    <div class="meta">
                        Última alteração: {{ settings?.updatedBy }} em
                        {{ $safeNavigationMigration(settings?.updatedAt) | date: 'dd/MM/yyyy HH:mm' }}
                    </div>
                    } @if (testResult) {
                    <div
                        class="test-result"
                        [class.ok]="testResult.ok"
                        [class.fail]="!testResult.ok"
                        role="status"
                    >
                        <strong>{{ testResult.ok ? '✔ Conexão OK' : '✖ Falha' }}</strong> —
                        {{ testResult.message }}
                        @if (testResult.elapsedMs != null) {
                        <span>({{ testResult.elapsedMs }} ms)</span>
                        }
                        <div class="meta">
                            Teste feito com os valores digitados, sem salvar. Ambiente:
                            {{ envLabel }}.
                        </div>
                    </div>
                    }
                    <div class="actions">
                        <button
                            mat-stroked-button
                            type="button"
                            (click)="test()"
                            [disabled]="testing || saving"
                        >
                            {{ testing ? 'Testando…' : 'Testar conexão' }}
                        </button>
                        <button
                            mat-flat-button
                            color="primary"
                            type="submit"
                            [disabled]="saving || !settings?.encryptionAvailable"
                        >
                            {{ saving ? 'Salvando…' : 'Salvar' }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
        }
    </section>
</admin-layout>
